import { BORDER, CARD, DARK, MID } from "../theme";
import { LOADING_TEXT, LOAD_ERROR_CONTENT, emptyStateContent } from "../dataState";

// ─── NO-DATA SCREENS ──────────────────────────────────────────────────────────
// Shown on every tab except Upload Data when the account's own numbers are not on screen: still loading,
// failed to load, or no jobs yet. Never sample data. Text comes from src/dataState.js.
// One plain sentence per tab for the empty state.
const TAB_NOTES = {
  dashboard: "Your profit by job will show up here.",
  clients: "Your clients will show up here.",
  inbox: "Expenses to assign will show up here.",
  detail: "Each job's numbers will show up here.",
  estimator: "Quotes use your past jobs, so they will be here once you have some.",
  reports: "Your reports will show up here.",
  chat: "Answers about your jobs will show up here.",
  raw: "Your transactions will show up here.",
};

function DataStateNotice({ state, tab, clientType, qbConnected, qbStarting, syncing, onConnect, onSync, onUpload, onRetry }) {
  const box = { margin:"48px auto", maxWidth:520, padding:"32px 36px", borderRadius:8, border:`1px solid ${BORDER}`, background:CARD, textAlign:"center", fontFamily:"'DM Sans',sans-serif" };
  if (state === "loading") {
    return (
      <div className="r-notice" style={box} role="status">
        <span className="spinner"/>
        <div style={{ fontSize:13, color:MID, marginTop:12 }}>{LOADING_TEXT}</div>
      </div>
    );
  }
  if (state === "error") {
    return (
      <div className="r-notice" style={box} role="alert">
        <h2 style={{ fontFamily:"'Lora',serif", fontSize:18, fontWeight:500, color:DARK, marginBottom:8 }}>{LOAD_ERROR_CONTENT.title}</h2>
        <p style={{ fontSize:13, color:MID, lineHeight:1.6, marginBottom:20 }}>{LOAD_ERROR_CONTENT.body}</p>
        <button className="btn act" onClick={onRetry}>Try again</button>
      </div>
    );
  }
  const c = emptyStateContent(clientType, qbConnected);
  const label = c.action === "connect" ? (qbStarting ? "Connecting…" : "Connect QuickBooks") : c.action === "sync" ? (syncing ? "Syncing…" : "Sync QuickBooks") : "Upload a spreadsheet";
  const onClick = c.action === "connect" ? onConnect : c.action === "sync" ? onSync : onUpload;
  const busy = (c.action === "connect" && qbStarting) || (c.action === "sync" && syncing);
  return (
    <div className="r-notice" style={box}>
      <h2 style={{ fontFamily:"'Lora',serif", fontSize:18, fontWeight:500, color:DARK, marginBottom:8 }}>{c.title}</h2>
      <p style={{ fontSize:13, color:MID, lineHeight:1.6, marginBottom:20 }}>{c.body}{TAB_NOTES[tab] ? ` ${TAB_NOTES[tab]}` : ""}</p>
      <button className="btn act" disabled={busy} onClick={onClick}>{label}</button>
    </div>
  );
}

export { DataStateNotice };
